import Vue from 'vue';
import axios from 'axios';

const miniCartModule = {
  namespaced: true,

  state: {
    items: [],
    bikes: {},
    parts: {},
    customWaterBottles: {},
    projectOneBikes: {},
    cart: {},
    containers: null,
  },

  getters: {
    totalItems: (state) => {
      return state.cart.details.totalQuantity;
    },
  },

  mutations: {
    setBikes(state, payload) {
      Vue.set(state, 'bikes', payload);
    },

    setParts(state, payload) {
      Vue.set(state, 'parts', payload);
    },

    setCustomWaterBottles(state, payload) {
      Vue.set(state, 'customWaterBottles', payload);
    },

    setProjectOneBikes(state, payload) {
      Vue.set(state, 'projectOneBikes', payload);
    },

    setCart(state, payload) {
      Vue.set(state, 'cart', payload);
    },

    setItems(state, payload) {
      Vue.set(state, 'items', payload);
    },
    setContainers(state, payload) {
      Vue.set(state, 'containers', payload);
    },
  },

  actions: {
    fetchMiniCart({commit}) {
      axios.get('/minicart/simplified/').then(({data}) => {
        if (data && data.data) {
          commit('setBikes', data.data?.subTotals?.BIKE || {});
          commit('setParts', data.data?.subTotals?.AFTERMARKET || {});
          commit('setCustomWaterBottles', data.data?.subTotals?.BONTRAGER_CUSTOM_BOTTLE || {});
          commit('setProjectOneBikes', data.data?.subTotals?.P1_BIKE || {});
          if (!data.data.details.hasOwnProperty('totalQuantity')) {
            data.data.details.totalQuantity = 0;
          }
          commit('setCart', data.data);

          if (data.data.dropShipContainer) {
            commit('setContainers', data.data.dropShipContainer);
          }
        }
      });
      return true;
    },
  },
};

export default miniCartModule;
